import { Zap } from "lucide-react";

const items = [
  "Motorista Bolt",
  "Formação IMT 50h",
  "Exame incluído",
  "Inscrições abertas",
  "Grupo IFT",
  "B-learning flexível",
];

export default function Marquee() {
  const row = [...items, ...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#34d186]/15 bg-[#fafafa] py-5">
      <div className="marquee-track flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className={`font-display text-2xl font-bold uppercase tracking-wide sm:text-3xl ${i % 2 === 0 ? "text-[#171717]" : "text-stroke-bolt"}`}>
                  {item}
                </span>
                <Zap size={18} className="shrink-0 text-[#34d186]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
